import { AuthorCard } from '../interfaces/author-card.interface';

export const plananualchilepb: AuthorCard[] = [
  {
    name: '¿Quién eres?',
    id: 18297,
    owner: {
      id: 36212,
      email: 'contacto@simarobot.com',
      name: 'Plan Anual de Chile',
      organizations: [{ name: 'Plan Anual de Chile' }],
    },
    biography:
      'Actividades lúdicas, que favorecen el desarrollo del lenguaje y comunicación en niños y niñas de primero básico',
    lock: true,
    level: 'pb',
    urlteacher: 'https://app.box.com/s/40br30cnnzz7as3apwe90noti9ffb15g',
    //urlpartent: 'https://app.box.com/s/wf4vdhzavwtrewbw8z4z4e6xpt948rjq',
    typeact: "unique",
    month:"36708"
  },
  {
    name: 'El Verano',
    id: 18301,
    owner: {
      id: 36212,
      email: 'contacto@simarobot.com',
      name: 'Plan Anual de Chile',
      organizations: [{ name: 'Plan Anual de Chile' }],
    },
    biography:
      'English activities designed as short learning capsules for 7th, 8th and 9th grades',
    lock: false,
    level: 'pb',
    urlteacher: 'https://app.box.com/s/rp2i4u3idyxdxs3tmwekb5wexe7n7vkj',
    //urlpartent: 'https://app.box.com/s/dj3ety6vvj07n38rsv8bdcyetvs37xh8',
    typeact: "unique",
    month:"36708"
  },
  {
    name: 'Momentos del día',
    id: 33702,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'contacto@simarobot.com',
      name: 'Plan Anual de Chile',
      organizations: [{ name: 'Plan Anual de Chile' }],
    },
    typeact: "unique",
    month:"36708",
    urlteacher:'https://app.box.com/s/dpu2pkysixg130wk3dw6n6pm1hu4dz8r',
    //urlpartent:"https://app.box.com/s/ha5wa2er1hpf99lt864v06eo8zx1ke8j"
  },
  {
    name: '¡Al ritmo del movimiento!',
    id: 33703,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36709",
    urlteacher:'https://app.box.com/s/f6amyow697frpr00vsoc11vng3bxcjw7',
    //urlpartent:"https://app.box.com/s/64wcokb440kl97vypjc9ip4pvnlvsskc"
   },
  {
    name: 'Normas de convivencia',
    id: 18302,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact:"unique",
    month:"36709",
    urlteacher:'https://app.box.com/s/y0v9vk47qf0vxgv1a2sbcqoav5skdwdb',
    //urlpartent:"https://app.box.com/s/of173kfpcilg03gqynet53cjj0wwba52"  
  },
  {
    name: 'La Magia de los Libros',
    id: 21063,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact:"unique",
    month:"36709",
    urlteacher:'https://app.box.com/s/ibkmn738s6rmzv1otrfs35ijqfdxdxyr',
    //urlpartent:"https://app.box.com/s/xlwafaf6vy4yoz6edsjwsb324i8fgr6v" 
  },
  {
    name: 'Día de la Tierra',
    id: 21064,
    biography:
      'Actividades lúdicas, que favorecen el desarrollo del lenguaje y comunicación en niños y niñas de primero básico',
    lock: true,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36709",
    urlteacher:'https://app.box.com/s/p7kgrt9n1q56hqjnh27lmszz25rkgwb1',
    //urlpartent:"https://app.box.com/s/a7d4ssuiifnnxow3srhqaw0kcgwq06yf"  
  },
  {
    name: 'Hagamos un Experimento',
    id: 21068,
    biography:
      'English activities designed as short learning capsules for 7th, 8th and 9th grades',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36709",
    urlteacher:'https://app.box.com/s/t1xd6alkzd6vo7m534osxxgqsb1mxagw',
    //urlpartent:"https://app.box.com/s/1zm27euf48nlh0ud8k8y1xaypmk1843a"  
  },
  {
    name: 'Día de los mamíferos marinos',
    id: 33834,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36710",
    urlteacher:'https://app.box.com/s/xm44wu8xf0ivgtordxfs97ru9fefnwx8',
    //urlpartent:"https://app.box.com/s/pzpei2y8qlauptcjci100mgdd3yjy2f5" 
  },
  {
    name: '¿En qué estación estamos?',
    id: 33900,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36710",
    urlteacher:'https://app.box.com/s/zz3o4e5m3jj0633qkx3gifip20c3548v',
    //urlpartent:"https://app.box.com/s/6tff96fkz3lwaj1sa25feritvgwkao39"  
  },
  {
    name: 'Día del y la estudiante',
    id: 33933,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36710",
    urlteacher:'https://app.box.com/s/v7xbasakgnr1js0cj2t1gcmmv89hrwwi',
    //urlpartent:"https://app.box.com/s/0grg06uisq2wxnjiyhqlpcmtdhr70vdl" 
  },
  {
    name: 'Somos artistas',
    id: 33934,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36710",
    urlteacher:'https://app.box.com/s/hrqyh8xoamijntk8tc6z9e1v71f3aslc',
    //urlpartent:"https://app.box.com/s/slhtte68a6wezl4u43rlfrju4sqjfe71"  
  },
  {
    name: 'La vida en el mar',
    id: 18324,
    biography:
      'Actividades lúdicas, que favorecen el desarrollo del lenguaje y comunicación en niños y niñas de primero básico',
    lock: true,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36711",
    urlteacher:'https://app.box.com/s/g163wd0zq8ezsvchnbkc3xmpk2wq0ssu',
    //urlpartent:"https://app.box.com/s/wiib01jtapr2xhc7zo6lhq641yepv4oe" 
  },
  {
    name: 'Nuestro ambiente',
    id: 18327,
    biography:
      'English activities designed as short learning capsules for 7th, 8th and 9th grades',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36711",
    urlteacher:'https://app.box.com/s/kwrpussxvx4gn6s9lm3bdr5aou43jdzg',
    //urlpartent:"https://app.box.com/s/ir6n7ytqpn96ql0igh8kw88f6pbr7bwx" 
  },
  {
    name: 'Cuando crezca quiero ser...',
    id: 18325,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36711",
    urlteacher:'https://app.box.com/s/h226251clixlqtb7jdv81pkvgk97g6qn',
    //urlpartent:"https://app.box.com/s/hiu3azm5o3nhytcq2q8kkk4y5w3ypqkp" 
  },
  {
    name: 'Día de la bandera nacional',
    id: 34659,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36712",
    urlteacher:'https://app.box.com/s/3mf32sb5sq6jo0rxcehku1gpgyrll7wr',
    //urlpartent:"https://app.box.com/s/zd4fl01aq1y1uqjqwe2pyt71zhpglgeg" 
  },
  {
    name: 'El invierno',
    id: 18332,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36712",
    urlteacher:'https://app.box.com/s/tu0shn8soj7jxfj4gswx8i4p3uk89nla',
    //urlpartent:"https://app.box.com/s/m395ljr9onb3b36ztcwgtekjw8gik0d4" 
  },
  {
    name: 'Manejando mis emociones',
    id: 18357,
    biography: '',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36713",
    urlteacher:'https://app.box.com/s/b3u76o4essm7dfv306gtvj3kah95m7gop',
    //urlpartent:"https://app.box.com/s/69rhgsr05fkd310awqfwwlil24frmm3u" 
  },
  {
    name: 'Nuestro folklore',
    id: 18358,
    biography:
      'Actividades lúdicas, que favorecen el desarrollo del lenguaje y comunicación en niños y niñas de primero básico',
    lock: true,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36713",
    urlteacher:'https://app.box.com/s/727mi7ciekojnmmkr4iwoit3meea74qy',
    //urlpartent:"https://app.box.com/s/nki83x4pzstr0kdyf4sda4rbxjfcig9o"
  },
  {
    name: 'Día de la técnica en educación parvularia',
    id: 33936,
    biography:
      'English activities designed as short learning capsules for 7th, 8th and 9th grades',
    lock: false,
    level: '2',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36713",
    urlteacher:'https://app.box.com/s/ukr28n1vezus1iniec1u1inzzwfxoshv',
    //urlpartent:"https://app.box.com/s/hk4n8z80wn4fmicrflmr1agnqj2khyqy" 
  },
  {
    name: 'Fiestas patrias chilenas',
    id: 18362,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36714",
    urlteacher:'https://app.box.com/s/2yrlqgh6xxojvf9dvw7mp5779yeovmmm',
    //urlpartent:"https://app.box.com/s/eikndh5dnhab1w6bfhq1l9crtpm2v4eh" 
  },
  {
    name: 'Grandes mujeres chilenas',
    id: 18363,
    biography: '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36714",
    urlteacher:'https://app.box.com/s/qxc4k2hnsu6gi0fqgkdoah58lu9bw1o9',
    //urlpartent:"https://app.box.com/s/3q103u6nlgpez5g4ma2mhqpke5k1tzas" 
  },
  {
    name: 'Mi móvil dieciochero',
    id: 18365,
    biography: '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36714",
    urlteacher:'https://app.box.com/s/5ky0baxqk4aqn8kdf50r0c0a2vjqdc4d',
    //urlpartent:"https://app.box.com/s/hw4sg0wo1lrhgvhttqvs8e8rjzvnw3xd" 
  },
  {
    name: 'La Primavera',
    id: 33835,
    biography: '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36714",
    urlteacher:'https://app.box.com/s/3nqdsim3dngdatsfv0llx09q4xwn91wp',
    //urlpartent:"https://app.box.com/s/4c10nyhif5h3m1qc4tkgg6b9qm7iib69" 
  },
  {
    name: 'La Música',
    id: 18395,
    biography:
      'Actividades lúdicas, que favorecen el desarrollo del lenguaje y comunicación en niños y niñas de primero básico',
    lock: true,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36715",
    urlteacher:'https://app.box.com/s/jotb3z7ivl72y94lxuw97xsu0ol8vszc',
    //urlpartent:"https://app.box.com/s/eeono8ty1mzlpxf294zew3k4drbx92y6" 
  },
  {
    name: 'Encuentro de dos mundos',
    id: 33939,
    biography:
      'English activities designed as short learning capsules for 7th, 8th and 9th grades',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36715",
    urlteacher:'https://app.box.com/s/y00xi51afhyg6q604wvk3xw26e914rrp',
    //urlpartent:"https://app.box.com/s/0bysiek2aj0t3a774x0igcfpz1plrf78" 
  },
  {
    name: '¿Qué es la interculturalidad?',
    id: 18393,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36715",
    urlteacher:'https://app.box.com/s/shyones1tjpv7l7puc00cms5ztfe261j',
    //urlpartent:"https://app.box.com/s/o2e252nby8n02bs3i7zk9qt5vmceq1b5"
  },
  {
    name: 'Mi querido profesor',
    id: 18392,
    biography: '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36715",
    urlteacher:'https://app.box.com/s/m67qj9bm3srt6tib1c30c19ro5pdrysr',
    //urlpartent:"https://app.box.com/s/id6799vzquzfx5wcmd1okj24hkmgcvem" 
  },
  {
    name: 'Educación para todos',
    id: 18396,
    biography: '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36716",
    urlteacher:'https://app.box.com/s/obfatnawl6wig6vw4klyu4u0cr0zcj40',
    //urlpartent:"https://app.box.com/s/906buzoc57as5wh80qcpwy3wwts4nyog" 
  },
  {
    name: 'Cada día me cuido más',
    id: 18399,
    biography: '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36716",
    urlteacher:'https://app.box.com/s/92odx3687degcfjc4yh2d88vhf06imv6',
    //urlpartent:"https://app.box.com/s/p1z1g1fiqb0tyc6mbd9i7c8kanlq0u45"  
  },
  {
    name: 'A festejar con los villancicos',
    id: 18427,
    biography:
      'Actividades lúdicas, que favorecen el desarrollo del lenguaje y comunicación en niños y niñas de primero básico',
    lock: true,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36717",
    urlteacher:'https://app.box.com/s/aflqe754orra24sywcanz0v85p4ttq7u',
    //urlpartent:"https://app.box.com/s/irwpt79pfj06h04yhs1b9ay6ztpyvr79" 
  },
  {
    name: 'Una linda navidad',
    id: 18428,
    biography:
      'English activities designed as short learning capsules for 7th, 8th and 9th grades',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36717",
    urlteacher:'https://app.box.com/s/aflqe754orra24sywcanz0v85p4ttq7u',
    //urlpartent:"https://app.box.com/s/lbs6o09u1uzimhbdntznuo0xh5l8f5os"  
  },
  {
    name: 'Somos únicos',
    id: 18429,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "unique",
    month:"36717",
    urlteacher:'https://app.box.com/s/njswluwstke5t15a1vk9g3cz3hbw3igd',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día Internacional de la Mujer',
    id: 71555,
    biography:
      '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Marzo",
    urlteacher:'',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Los Derechos de los Niños',
    id: 71558,
    biography:
      '',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Abril",
    urlteacher:'https://app.box.com/s/gs9x3mzhd1w5jgmn4emehlduux3xw7te',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día Nacional de las Ciencias',
    id: 70107,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Abril",
    urlteacher:'https://app.box.com/s/lgkmfsnx7mtfqogjomg61hhqdvp5671n',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día del Estudiante',
    id: 70136,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Mayo",
    urlteacher:'https://app.box.com/s/xqrz0nw3c0fifr9f5u86pju33rcblv17',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día de la Bandera',
    id: 70138,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Julio",
    urlteacher:'https://app.box.com/s/ak5c7atvym7scm8q7rpcsit0dy10s3mx',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: '¡Día del técnico en educación parvularia!',
    id: 70140,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Agosto",
    urlteacher:'https://app.box.com/s/sxg3ixj9vkvm67hlj5cxm55937m15ce6',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día del Folklore',
    id: 70141,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Agosto",
    urlteacher:'https://app.box.com/s/ldhvbb4nhelpdvsdvw410joexrx978n1',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día de la música',
    id: 70143,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Octubre",
    urlteacher:'https://app.box.com/s/bpcmz3mf2tzneu7yavmzapvbs5aw7okx',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Encuentro de Dos Mundos',
    id: 70146,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Octubre",
    urlteacher:'https://app.box.com/s/lpr4hhrdshlfc9njne6hpa81n7j3oon3',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  },
  {
    name: 'Día del Profesor',
    id: 70148,
    biography:
      'libros propuestos por la UNICEF, para abordar los derechos de los niños y niñas, así como temas de interés propio de la infancia.',
    lock: false,
    level: '3',
    owner: {
      id: 36212,
      email: 'kidint@simarobot.com',
      name: 'Fomento Lector kidint',
      organizations: [{ name: 'Kidint Schools' }],
    },
    typeact: "moments",
    month:"Octubre",
    urlteacher:'https://app.box.com/s/423lf7kwevbsjevv4wqe7ncx6x8g9hlg',
    //urlpartent:"https://app.box.com/s/v26hg2kcsfxwkersy1i1u5651iq4vaoq" 
  }
];
